import * as React from 'react';

import classNames from 'classnames';

interface IColumnProps {
	size?: number;
	desktopSize?: number;
	tabletSize?: number;
	fullHdSize?: number;
	offset?: number;
	isHidden?: boolean;
}

export default class Column extends React.Component<IColumnProps, {}> {
	public render() {
		const { size, offset, desktopSize, tabletSize, fullHdSize, isHidden } =
			this.props;

		if (isHidden) {
			return null;
		}

		const classes = classNames(
			'column',
			size && `is-${size}`,
			offset && `is-offset-${offset}`,
			desktopSize && `is-${desktopSize}-desktop`,
			tabletSize && `is-${tabletSize}-tablet`,
			fullHdSize && `is-${fullHdSize}-fullhd`
		);

		return <div className={classes}>{this.props.children}</div>;
	}
}
